<script setup lang="ts">
const route = useRoute();
const { t } = useI18n();
const { getBreadcrumbs, currentRoutSettingsPath } = useNavigation();

const breadcrumbItems = computed(() => {
  let items = getBreadcrumbs(route.path);

  if (items.length === 0 && route.meta.breadcrumb) {
    const parentPath = route.path.replace(/\/[^/]+$/, '');
    const parentItems = getBreadcrumbs(parentPath);
    if (parentItems.length > 0) {
      items = [...parentItems, { label: route.meta.breadcrumb as string }];
    }
  }

  return items.map((item, index) => ({
    label: t(item.label),
    icon: item.icon,
    to: index < items.length - 1 ? item.to : undefined,
  }));
});
</script>

<template>
  <div class="justify-between flex items-center mb-8">
    <UBreadcrumb v-if="breadcrumbItems.length > 1" :items="breadcrumbItems" />
    <UButton v-if="currentRoutSettingsPath !== null" icon="heroicons:cog-6-tooth" variant="ghost" class="" :to="currentRoutSettingsPath" />
  </div>
</template>
